module.exports = {
  src: __webpack_public_path__ + "static/media/glyphicons-earphone.80ed6709.png",
  width: 24,
  height: 24,
  bytes: 1398,
  type: "png",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/glyphicons-earphone.80ed6709.png";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/components/GetInTouch/icons/glyphicons-earphone.png
// module id = 139
// module chunks = 0